import React from "react";

const ModifierTable = () => {
  return (
    <>
      <section className="about-area pb-60 pt-60">
        <div className="container">
        <h2 className='pb-1' data-aos="fade-up" data-aos-delay="100">FORMULA ONE SERIES PAGE</h2>
        <p className='pb-1 lh-base' data-aos="fade-up" data-aos-delay="100">Prior to 1950 Formula One was known as the European Drivers Championship and was sanctioned by AIACR, the forerunner to FIA.</p>
       
          <table className="table  table-dark table-striped table-bordered border-light">
            <thead>
        
              <tr style={{ width: "100%" }}>
                <th scope="col"  style={{ textAlign: "center" }}>
                Year
                </th>
                <th scope="col"  style={{ textAlign: "center" }}>
                Races
                </th>
                <th scope="col"  style={{ textAlign: "center"}}>
                Driver Champion
                </th>
                <th scope="col"  style={{ textAlign: "center"}}>
                Driver Points
                </th>
                <th scope="col"  style={{ textAlign: "center"}}>
                Constructor Champion
                </th>
                <th scope="col"  style={{ textAlign: "center"}}>
                Constructor Points
                </th>
                <th scope="col"  style={{ textAlign: "center"}}>
                Engine
                </th>
          
              </tr>
            </thead>
          
            <tbody>
              <tr>
                <td style={{ textAlign: "center" }}>1</td>
                <td style={{ textAlign: "center" }}>11</td>
                <td style={{ textAlign: "center" }}>Pipo Derani Alexander Sims</td>
                <td style={{ textAlign: "center" }}>454</td>
                <td style={{ textAlign: "center" }}>Red Bull Racing</td>
                <td style={{ textAlign: "center" }}>759</td>
                <td style={{ textAlign: "center" }}>Ferrari</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2</td>
                <td style={{ textAlign: "center" }}>12</td>
                <td style={{ textAlign: "center" }}>Oliver Jarvis Tom Blomqvist</td>
                <td style={{ textAlign: "center" }}>395.5</td>
                <td style={{ textAlign: "center" }}>Mercedes</td>
                <td style={{ textAlign: "center" }}>613.5</td>
                <td style={{ textAlign: "center" }}>Renault</td>
                </tr>
              <tr>
                <td style={{ textAlign: "center" }}>3</td>
                <td style={{ textAlign: "center" }}>12</td>
                <td style={{ textAlign: "center" }}>Felipe Nasr Pipo Derani</td>
                <td style={{ textAlign: "center" }}>347	</td>
                <td style={{ textAlign: "center" }}>Mercedes</td>
                <td style={{ textAlign: "center" }}>573</td>
                <td style={{ textAlign: "center" }}>Red Bull Racing RBPT</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>4</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Helio Castroneves Ricky Taylor</td>
                <td style={{ textAlign: "center" }}>108</td>
                <td style={{ textAlign: "center" }}>Gar Robinson</td>
                <td style={{ textAlign: "center" }}>573</td>
                <td style={{ textAlign: "center" }}>Mercedes</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>5</td>
                <td style={{ textAlign: "center" }}>11</td>
                <td style={{ textAlign: "center" }}>Pipo Derani Alexander Sims</td>
                <td style={{ textAlign: "center" }}>76</td>
                <td style={{ textAlign: "center" }}>Gar Robinson</td>
                <td style={{ textAlign: "center" }}>170</td>
                <td style={{ textAlign: "center" }}>Ferrari</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>6</td>
                <td style={{ textAlign: "center" }}>12</td>
                <td style={{ textAlign: "center" }}>Oliver Jarvis Tom Blomqvist</td>
                <td style={{ textAlign: "center" }}>81</td>
                <td style={{ textAlign: "center" }}>Mercedes</td>
                <td style={{ textAlign: "center" }}>123</td>
                <td style={{ textAlign: "center" }}>Renault</td>
                </tr>
              <tr>
                <td style={{ textAlign: "center" }}>7</td>
                <td style={{ textAlign: "center" }}>12</td>
                <td style={{ textAlign: "center" }}>Felipe Nasr Pipo Derani</td>
                <td style={{ textAlign: "center" }}>347	</td>
                <td style={{ textAlign: "center" }}>Mercedes</td>
                <td style={{ textAlign: "center" }}>573</td>
                <td style={{ textAlign: "center" }}>Red Bull Racing RBPT</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>8</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Helio Castroneves Ricky Taylor</td>
                <td style={{ textAlign: "center" }}>108</td>
                <td style={{ textAlign: "center" }}>Gar Robinson</td>
                <td style={{ textAlign: "center" }}>303</td>
                <td style={{ textAlign: "center" }}>Mercedes</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>9</td>
                <td style={{ textAlign: "center" }}>11</td>
                <td style={{ textAlign: "center" }}>Pipo Derani Alexander Sims</td>
                <td style={{ textAlign: "center" }}>454</td>
                <td style={{ textAlign: "center" }}>Red Bull Racing</td>
                <td style={{ textAlign: "center" }}>759</td>
                <td style={{ textAlign: "center" }}>Ferrari</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>10</td>
                <td style={{ textAlign: "center" }}>12</td>
                <td style={{ textAlign: "center" }}>Oliver Jarvis Tom Blomqvist</td>
                <td style={{ textAlign: "center" }}>395.5</td>
                <td style={{ textAlign: "center" }}>Mercedes</td>
                <td style={{ textAlign: "center" }}>613.5</td>
                <td style={{ textAlign: "center" }}>Renault</td>
                </tr>
              <tr>
                <td style={{ textAlign: "center" }}>11</td>
                <td style={{ textAlign: "center" }}>12</td>
                <td style={{ textAlign: "center" }}>Felipe Nasr Pipo Derani</td>
                <td style={{ textAlign: "center" }}>347	</td>
                <td style={{ textAlign: "center" }}>Mercedes</td>
                <td style={{ textAlign: "center" }}>573</td>
                <td style={{ textAlign: "center" }}>Red Bull Racing RBPT</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>12</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Helio Castroneves Ricky Taylor</td>
                <td style={{ textAlign: "center" }}>108</td>
                <td style={{ textAlign: "center" }}>Gar Robinson</td>
                <td style={{ textAlign: "center" }}>573</td>
                <td style={{ textAlign: "center" }}>Mercedes</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>13</td>
                <td style={{ textAlign: "center" }}>11</td>
                <td style={{ textAlign: "center" }}>Pipo Derani Alexander Sims</td>
                <td style={{ textAlign: "center" }}>76</td>
                <td style={{ textAlign: "center" }}>Gar Robinson</td>
                <td style={{ textAlign: "center" }}>170</td>
                <td style={{ textAlign: "center" }}>Ferrari</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>14</td>
                <td style={{ textAlign: "center" }}>12</td>
                <td style={{ textAlign: "center" }}>Oliver Jarvis Tom Blomqvist</td>
                <td style={{ textAlign: "center" }}>81</td>
                <td style={{ textAlign: "center" }}>Mercedes</td>
                <td style={{ textAlign: "center" }}>123</td>
                <td style={{ textAlign: "center" }}>Renault</td>
                </tr>
              <tr>
                <td style={{ textAlign: "center" }}>15</td>
                <td style={{ textAlign: "center" }}>12</td>
                <td style={{ textAlign: "center" }}>Felipe Nasr Pipo Derani</td>
                <td style={{ textAlign: "center" }}>347	</td>
                <td style={{ textAlign: "center" }}>Mercedes</td>
                <td style={{ textAlign: "center" }}>573</td>
                <td style={{ textAlign: "center" }}>Red Bull Racing RBPT</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>16</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Helio Castroneves Ricky Taylor</td>
                <td style={{ textAlign: "center" }}>108</td>
                <td style={{ textAlign: "center" }}>Gar Robinson</td>
                <td style={{ textAlign: "center" }}>303</td>
                <td style={{ textAlign: "center" }}>Mercedes</td>
              </tr>
            
            </tbody>
          </table>
         
      
       
        </div>
      </section>
    </>
  );
};

export default ModifierTable;
